export const checkAndSetAppMode = () => {
    // Check URL parameters first
    const queryParameters = new URLSearchParams(window.location.search);
    const urlAppMode = queryParameters.get("appMode");

    if (urlAppMode === 'false') {
        // Remove appMode from localStorage if explicitly set to false
        localStorage.removeItem('appMode');
        return false;
    }

    // Check localStorage next
    const storedAppMode = localStorage.getItem('appMode');
    if (storedAppMode === 'true') {
        return true;
    }

    // If not in localStorage and URL is true, store it
    if (urlAppMode === 'true') {
        localStorage.setItem('appMode', 'true');
        return true;
    }

    return false;
};

export const isAppMode = () => {
    return localStorage.getItem('appMode') === 'true';
}; 